<script>
import { Doughnut } from 'vue-chartjs'
import moment from 'moment'
export default {
    extends: Doughnut,
    data() {
        var dates = this.inspections;
        var labels = dates;
        var that = this;
        var series = _.sortBy(_.keys(this.devices), function(c){
                return that.devices[c].dev_num;
            });
        var datas = _.map(series, (c) => {
            return _.round(
                _.sum(
                    _.values(
                        _.mapValues(dates[c], 'conditions'))
                    ) / (dates[c] || [null]).length, 2
                )
        });
        var todisplay = _.zipObject(series, datas);
        var label = 'średnia';
        var colors = _.map(series, (c) => { return that.randomGreyHex(); })
        var chartdatas = datas
        var numbers = _.map(series, (c) => { return that.devices[c].number; } )
        return {
            chartData: {
                labels: numbers,
                datasets: [
                  {
                    backgroundColor: colors,
                    data: chartdatas
                  }
                ]
              },
            options: {
                responsive: true, 
                plugins: {
                  legend: {
                    position: 'right',
                  },
                },
                 maintainAspectRatio: false, 
                 animation: {
                   animateRotate: false
                }
            }
        }
    },
    methods: {
        randomGreyHex() {
            var letters = '0123456789ABCDEF'.split('');
            var color = '#';
            for (var i = 0; i < 6; i++ ) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        }
    },
    props: {
        inspections: Object,
        devices: Object,
        color: String,
        mode: String
    },
    watch: {
        devices:  function (newInspections, oldInspections) {
           this.renderChart(this.chartData, this.options) 
        },
        inspections:  function (newInspections, oldInspections) {
           this.renderChart(this.chartData, this.options) 
        },
        mode:  function (newInspections, oldInspections) {
           this.$forceUpdate()
           this.renderChart(this.chartData, this.options) 
        }
    },
    mounted() {
        this.renderChart(this.chartData, this.options)
    }
}
</script>